import {ContactItem, SearchContactItemByMail} from '../../model/ManagePOIListItem';
import ServiceEndpoints from "../ServiceEndpoints"
import { EIOPAError } from "../../model/EIOPAError";

export async function fetchCP(userToken?: string) {
    return await fetch(ServiceEndpoints.FetchAllCP, {
        method: 'get',
        headers: { "Content-Type": "application/json", "Authorization": "Bearer " + userToken },
    }).then(async (resp) => {
        const parsedData: ContactItem[] = await resp.json();
        return parsedData;
    }).catch((error) => {
        console.error(error);
        return [];
    });
}

export async function fetchCPByMail(mail: string, userToken?: string, isEncryptedMail: boolean = false) {
    const searchContactItemByMail: SearchContactItemByMail = {
        mail: mail,
        isEncryptedMail: isEncryptedMail
    };

    return await fetch(ServiceEndpoints.FetchCPByMail, {
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + userToken
        },
        body: JSON.stringify(searchContactItemByMail)
    }).then(async (resp) => {
        const parsedData: ContactItem[] = await resp.json();
        return parsedData;
    }).catch((error) => {
        console.error(error);
        return [];
    });
}

// Function for updating an Contact item
export async function UpdateContactById(encryptedId: string, updatedContact: ContactItem, userToken?: string) {
    try {
        const response = await fetch(`${ServiceEndpoints.UpdateContactById}/${encryptedId}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json', "Authorization": "Bearer " + userToken,
            },
            // Convert the updated Contact object to a JSON string and include it in the request body
            body: JSON.stringify(updatedContact),
        });

        if (response.ok) {
            // If the update is successful, parse and return the response data (if any)
            return response.ok;
        } else {
            // if response has a payload, throw an error
            const text = await response.text();
            if (response.status === 400 && text) {
                throw new EIOPAError(text);
            } else {
                // If there is an error response from the server, throw an error
                throw new Error('Error updating Contact data.');
            }

        }
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export async function CreateContact(createdContact: ContactItem, userToken?: string) {
    try {
        const response = await fetch(ServiceEndpoints.CreateContact, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json', "Authorization": "Bearer " + userToken,
            },
            // Convert the updated Contact object to a JSON string and include it in the request body
            body: JSON.stringify(createdContact),
        });

        if (response.ok) {
            // If the update is successful, parse and return the response data (if any)
            return response.ok;
        } else {
            // if response has a payload, throw an error
            const text = await response.text();
            if (response.status === 400 && text) {
                throw new EIOPAError(text);
            } else {
                // If there is an error response from the server, throw an error
                throw new Error('Error creating Contact.');
            }
        }
    } catch (error) {
        console.error(error);
        throw error;
    }
}

// Function for deleting an Contact item
export async function DeleteContactById(id: number, userToken?: string) {
    try {
        // Send a DELETE request to the server's DeleteContact endpoint
        const response = await fetch(`${ServiceEndpoints.DeleteContactById}/${id}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json', "Authorization": "Bearer " + userToken,
            },
        });
        // Check if the response is successful (HTTP status 200-299)
        if (response.ok) {
            // If the deletion is successful, parse and return the response data (if any)
            return response.json();
        } else {
            // If there is an error response from the server, throw an error
            throw new Error('Error deleting Contact data.');
        }
    } catch (error) {
        // Handle any errors that occur during the fetch operation
        console.error(error);
        throw error;
    }
}
